<div *ngIf="session && (expiresInSeconds || 0) > 0">

  <data-preview
    *ngIf="session?.identity"
    [defaultSectionName]="'Identity'"
    [item]="session.identity"
    [options]="{
      properties: {
        'sub': {
          heading: 'Account',
          order: -1
        },
        'claims': {
          heading: 'Claims',
          order: 0,
          valueRenderTemplate: claimsTemplate
        },
        'tenants': {
          heading: 'Tenants',
          order: 1,
          valueRenderTemplate: tenantsTemplate
        },
        'exp': {
          heading: 'Expires In',
          valueRenderTemplate: expirationTemplate
        },
        'nbf': {
          heading: 'NBF'
        },
        'jti': {
          heading: 'JTI'
        },
        'csrf': {
          heading: 'CSRF'
        },
        'iat': {
          heading: 'IAT'
        },
        'fresh': {
          heading: 'Refresh Token'
        },
        'type': {
          heading: 'Token Type'
        }
      }
    }"
  ></data-preview>
  <actions-container [ngClass]="'pb-4'">
    <button mat-raised-button [color]="'warn'" class="me-2" [routerLink]="'/account/reset-password'">
      Reset Password
    </button>
    <back-button></back-button>
  </actions-container>
</div>

<ng-template #expirationTemplate>
  <div *ngIf="expiresInSeconds">
    <uptime-view [seconds]="expiresInSeconds"></uptime-view>
  </div>
</ng-template>

<ng-template #claimsTemplate let-propertyValue=propertyValue>
  <div *ngIf="propertyValue">
    <span *ngFor="let c of propertyValue; let last=last">
      {{c.type}} <span *ngIf="c.value">({{c.value}})</span>
      <span *ngIf="!last">, </span>
    </span>
  </div>
</ng-template>

<ng-template #tenantsTemplate let-propertyValue=propertyValue>
  <div *ngIf="propertyValue">
    <span *ngFor="let c of propertyValue; let last=last">
      {{c}}
      <span *ngIf="!last">, </span>
    </span>
  </div>
</ng-template>
